import {useEffect, useState, useContext} from "react";
import './about-me.scss';
import meBlack from '../../Assets/Image/meBlack.webp';
import meWhite from '../../Assets/Image/meWhite.webp';
import ScrollTopContext from "../../Contexts/ScrollTop";
import LanguageContext from "../../Contexts/Language";
import Button from "../Button/Button";
import { ReactComponent as Arrow} from '../../Assets/Svg/arrow.svg';
type AboutMeProps = {
    scrollTop: number
    height: number,
}

const AboutMe = (props: AboutMeProps) =>{
    const {language} = useContext(LanguageContext);
    const {setScrollTop} = useContext(ScrollTopContext);
    const [isVisible, setIsVisble] = useState<Boolean>(false);
    
    const [rotateX, setRotateX] = useState(0);
    const [rotateY, setRotateY] = useState(0);
    
    const rotation = 10
    useEffect(() =>{
        setIsVisble((props.scrollTop / (6092 / (window.outerWidth / window.innerWidth))) > 0  && (props.scrollTop / (6092 / (window.outerWidth / window.innerWidth))) < 350 / 6092);
    },[props.scrollTop])

    const imageMove = (e: any) =>{
        if(isVisible){
            setRotateX(((e.screenX) / window.innerWidth));
            setRotateY(((e.screenY) / window.innerHeight));
        }
    }

    return(
        <div className={`about-me about-me-visible-${isVisible}`} onMouseMove={(e) =>{imageMove(e)}} style={{height: `${props.height}px`}}>
            <div className="about-me-text">
                {language.aboutMe[0].split("XXX").map((text,key) => (key % 2 === 1 ? <span className="skill-link" key={key} onClick={() => { setScrollTop(1900)}}>{text}</span> : <span key={key}>{text}</span>))}
                {/* <div className="cv-wrapper">
                    <Button className="cv-download" href={`files/curriculum_vitae_${language.id}.pdf`} download><Arrow/>{language.aboutMe[1]}<Arrow/></Button>
                </div> */}
            </div>
            <div className="about-me-image" style={{transform: `translate(-50%,-50%)perspective(1000px)rotateX(${(rotateY * -rotation) + (rotation / 2)}deg)rotateY(${(rotateX * rotation) -(rotation / 2)}deg)`}}>
                <img className="img img-black" src={meBlack} alt="me in black" fetchPriority="high"/>
                <img className="img img-white" src={meWhite} alt="me in white" fetchPriority="high"/>
            </div>
            <div className="about-me-dots">
                <div className="dot">
                    <div className="dot-foreground" style={{transform: `translate(0,${props.scrollTop - 100}%)`}}/>
                </div>
                <div className="dot">
                    <div className="dot-foreground" style={{transform: `translate(0,${props.scrollTop - 200}%)`}}/>
                </div>
                <div className="dot">
                    <div className="dot-foreground" style={{transform: `translate(0,${props.scrollTop - 300}%)`}}/>
                </div>
            </div>
        </div>
    )
}
export default AboutMe